<template lang="pug">
  v-menu(:offset-y='offsetY || false')
    v-btn(v-if='includeButton' slot="activator" flat icon)
      v-icon(color="grey") {{ icon }}
    v-icon(v-else color='grey' slot='activator') {{ icon }}
    v-list
      v-list-tile(
        v-for='(item, index) in actions'
        :key='index'
        @click='redirectTo(item)'
        )
        v-list-tile-action
          v-icon {{ item.icon }}
        v-list-tile-content
          v-list-tile-title(v-text='item.title')
</template>

<script>
export default {
  /**
   * This component is used predominately on tables currently, it was made
   * in an effort to generalize a menu to be used in any table where you have a column
   * for actions. This is normally signified by the more_vert (triple dot) icon,
   * so that is the default in this case.
   */
  props: {
    offsetY: {
      type: Boolean,
    },
    icon: {
      type: String,
      default: 'more_vert',
    },
    actions: {
      type: Array,
    },
    includeButton: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
    },
  },
  computed: {
    dataItem() {
      if (this.data.item) {
        return this.data.item;
      }
    },
  },
  methods: {
    redirectTo(item) {
      const route = {
        name: item.pathName,
      };

      if (item.id && item.name) {
        route.params = { id: item.id, name: item.name };
      }
      this.$router.push(route);
    },
  },
};
</script>
